import { Component, HostListener, OnInit } from '@angular/core';
import { DialogService } from 'src/app/shared/services/dialog.service';

@Component({
    selector: 'app-intro',
    templateUrl: './intro.component.html',
    styleUrls: ['./intro.component.scss'],
})
export class IntroComponent implements OnInit {
    showDialog = false;
    activeComponent;

    constructor(private dialogService: DialogService) {}

    ngOnInit(): void {
        this.dialogService.activeComponent().subscribe((activeComponent) => {
            if (!activeComponent) {
                this.closeDialog();
            }
            this.activeComponent = activeComponent;
        });
    }

    @HostListener('click', ['$event'])
    public handleClick(event) {
        if (event.target.id == 'container') {
            console.log('clicked on dialog');
            this.openDialog();
        }
    }

    @HostListener('document:keydown', ['$event'])
    onKeyDownHandler(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            this.closeDialog();
        }
    }

    openDialog() {
        this.showDialog = !this.showDialog;
    }

    closeDialog() {
        this.showDialog = false;
    }
}
